import { I18nStrings } from './index';

export const de: I18nStrings = {
  cardTitle: (num: number, side: 'front' | 'back') =>
      `Karte ${num} (${side === 'front' ? 'Vorderseite' : 'Rückseite'})`,
  insertFlipCard: 'Wendekarte einfügen',
  frontSide: 'Vorderseite',
  backSide: 'Rückseite',
  flipToBack: 'Zur Rückseite drehen',
  flipToFront: 'Zur Vorderseite drehen',
  clickToFlip: 'Klicken zum Drehen',
  addText: 'Text hinzufügen',
  addTextPlaceholder: 'Text eingeben...',
  addImage: 'Bild hinzufügen',
  insertImage: 'Bild einfügen',
  uploadFile: 'Datei hochladen',
  urlPlaceholder: 'Bild-URL eingeben...',
  ok: 'OK',
  cancel: 'Abbrechen',
  copyCard: 'Karte kopieren',
  deleteCard: 'Karte löschen',
  resetFace: 'Zurücksetzen',
  dragHandle: 'Ziehen zum Neuordnen',
  or: 'oder'
};
